import { render, staticRenderFns } from "./RedeemGiftCard.vue?vue&type=template&id=783dbe20&"
import script from "./RedeemGiftCard.vue?vue&type=script&lang=ts&"
export * from "./RedeemGiftCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Buildserver\\Agent01\\_work\\1030\\s\\JCD.Retail.Webshop\\App\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('783dbe20')) {
      api.createRecord('783dbe20', component.options)
    } else {
      api.reload('783dbe20', component.options)
    }
    module.hot.accept("./RedeemGiftCard.vue?vue&type=template&id=783dbe20&", function () {
      api.rerender('783dbe20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/webshop/components/giftcard/RedeemGiftCard.vue"
export default component.exports